//  non-dynamic
import SGalleryLanding from "./SGalleryLanding_web"
export default SGalleryLanding
